import React, { useState, useRef, useEffect } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';

import CommonBtn from '@views/components/CommonBtn';
import Toast from '@widgets/Toast';
import userStore from '@stores/user';
import { IChildBasicInfo } from '@apis/types';
// import emptyImage from './images/common_empty.png';
import defaultAvatar from '@images/avatar_default.png';
import {pushAndPopUntil} from '@helpers/BrowserHistory';
import EmptyView from '@views/sections/EmptyView';
import FridayService from '@services/friday';

const DeviceBindChild = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [childrenList, setChildrenList] = useState<IChildBasicInfo[]>(null);

  const initData = async() => {
    const { data } = await Http.post(
      Api.GetChildrenListByUserUid,
      { userUid:  userStore.userInfo.uid }
    )
    setChildrenList(data || []);
  }

  const renderChildren = () => {
    const bindChild = (child: IChildBasicInfo) => {
      FridayService.addEvent('bind_device_bind_child_bind_button_click');

      Http.post(
        Api.PostDeviceBindChild,
        { bindSchoolUid: child.schoolUid || '',
          bindUserUid: child.userUid,
          bindOwnerUid: userStore.userInfo.uid,
          phone: params.current.phone,
          snCode: params.current.sncode,
          company: params.current.company,
          rfid: params.current.rfid,
          secretCode: params.current.secretCode,
          version: params.current.version }
      ).then(async() => {
        FridayService.addEvent('bind_the_device_bind_successfully_show');
        Toast.show({
          type: 'strip',
          title: '绑定成功'
        });

        setTimeout(() => {
          pushAndPopUntil(`${PUBLIC_URL}/myDevices?selectedDeviceSN=${params.current.sncode}&showLocationWindow=true`, ['/myDevices', '/']);
        }, 500);
      })
    }

    const items =  childrenList.map((child: IChildBasicInfo, index: number) => {
      return (
        <div className='flex' key={index} styleName="item-container">
          <img src={ child.photoUrl || defaultAvatar } alt="" styleName='item-icon'/>
          <div className='flex' styleName='item-right-container'>
            <div className='flex' styleName='item-text-container'>
              <p styleName='item-title'>{child.realName}</p>
              {(child.schoolName && child.className) ?
                  (<p styleName='item-subtext'>{`${child.schoolName}/${child.className}`}</p>) : null}
            </div>
            {child.electronicStudentIdSnCode && child.electronicStudentIdSnCode.length > 0 ? (
              <p styleName='item-righttext'>已绑定</p>
            )
            : (
            <CommonBtn btnText="绑 定"
              style={{ fontSize: '.28rem', width: '1.3rem', height: '.64rem', borderRadius: '.16rem', margin: 0}}
              onConfirm={() => bindChild(child)}/>
              )
            }

          </div>
        </div>
      )
    });
    return (<div styleName="children-list">{items}</div>);
  }

  useEffect(() => {
    initData();
  }, []);

  return (
    <div styleName="container">
      <NavBar
        title="绑定孩子"
      />
      {childrenList && childrenList.length > 0 &&
        (<div className='flex' styleName='content'>
          <div styleName='sub-text'>请选择要绑定的孩子：</div>
          {renderChildren()}
          <div className='flex flex-center' styleName='sub-text'>没有孩子信息？请联系学校添加孩子</div>
        </div>) }
      {childrenList && childrenList.length === 0 &&
        (
          <EmptyView
            title={
              <>
                <div>没有孩子信息？</div>
                <div>请联系学校添加孩子</div>
              </>
            }
          />
        )
      }
    </div>
  )
}

export default DeviceBindChild;
